module.exports = __webpack_public_path__ + "img/20250415-180420.c3244afb.png";